import { EditViewEnum } from '../models/edit-view.enum';
import { CanvasSizeModel } from '../models/canvas-size.model';

export class SetView {
  static readonly type = '[Edit] Set view';
  constructor(public view: EditViewEnum) { }
}

export class NextView {
  static readonly type = '[Edit] Next view';
  constructor() { }
}

export class Preview {
  static readonly type = '[Edit] Preview';
  constructor(
    public quizLocked = false,
    public quizQuestion?: number
  ) { }
}

export class PreviousView {
  static readonly type = '[Edit] Previous view';
  constructor() { }
}

export class ShowColumns {
  static readonly type = '[Edit] Show columns';
  constructor(public show: boolean) { }
}

export class ShowColumn {
  static readonly type = '[Edit] Show column';
  constructor(public column: 'left' | 'right' | 'header' | 'footer', public show: boolean) { }
}

export class ResetEditPage {
  static readonly type = '[Edit] Reset';
  constructor() { }
}

export class SetLayerOrderMode {
  static readonly type = '[Edit] Set Layer Order Mode';
  constructor(public layerOrderMode: boolean) {}
}

export class ShowTreeNodeIds {
  static readonly type = '[Edit] Show Tree Node Ids';
  constructor(public show?: boolean) {}
}

export class SetCanvasSize {
  static readonly type = '[Edit] Set Canvas Size';
  constructor(public size: CanvasSizeModel) {}
}

export class AutoCapture {
  static readonly type = '[Edit] Auto Capture';
  constructor(public enable: boolean) {}
}
